module.exports = __webpack_public_path__ + "static/script_p1-8d0ccadc130dd856d46fc945074f3700.png";